import axios from 'axios';

const api = axios.create({
  baseURL: `${window.INOVA_PRESETS.APP_SERVICE_URL}/v3/`,
});

export default api;

